module.exports = __webpack_public_path__ + "static/media/cw_article_editing.ed9871a8.png";